import { useEffect } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { AttachLabel, MAX_RECONNECT_ATTEMPTS, SocketStatus } from "../../../../../shared/config";
import { getMessageText, useOnlineStatus } from "../../../../../shared/lib";
import { FSMStages, useAppDispatch, useAppSelector, useCommunicationContext, useFSM } from "../../../../../shared/model";
import { selectReconnectCount, setReconnectCount } from "../../../model/redux";
import { selectResubmitMessages } from "../../../../message/model";
import { MessageType } from "../../../../../shared/api";
import { ymPushResendAttach } from "../../../../../shared/analytics";
export var useConnectionHandler = function useConnectionHandler(params) {
  var socketRef = params.socketRef,
    socketStatus = params.socketStatus,
    connect = params.connect,
    config = params.config;
  var dispatch = useAppDispatch();
  var isOnline = useOnlineStatus();
  var _useFSM = useFSM(),
    stage = _useFSM.stage,
    changeStage = _useFSM.changeStage;
  var _useCommunicationCont = useCommunicationContext(),
    resendMessage = _useCommunicationCont.resendMessage,
    resendImageMessage = _useCommunicationCont.resendImageMessage,
    sendFileMessage = _useCommunicationCont.sendFileMessage;
  var reconnectCount = useAppSelector(selectReconnectCount) || 0;
  var resubmitMessages = useMutableRef(useAppSelector(selectResubmitMessages));
  var resubmitMessage = function resubmitMessage(message) {
    var messageData = message.message,
      messageId = message.messageId;
    var text = getMessageText(message);
    if (text) {
      resendMessage(text, messageData.replyId, messageId === null || messageId === void 0 ? void 0 : messageId.toString(), {
        value: messageData === null || messageData === void 0 ? void 0 : messageData.value,
        messageType: messageData.type
      });
    }
    if (messageData.type === MessageType.FileDoc && messageData.fileId) {
      var _config$authZoneConfi;
      sendFileMessage(messageData.fileId, message, true);
      ymPushResendAttach(AttachLabel.FIlE, (_config$authZoneConfi = config.authZoneConfig) === null || _config$authZoneConfi === void 0 ? void 0 : _config$authZoneConfi.zoneType);
    }
    if (messageData.type === MessageType.Img && messageData.fileId && messageData.filePreviewId) {
      var _config$authZoneConfi2;
      resendImageMessage({
        imageId: messageData.fileId,
        imagePreviewId: messageData.filePreviewId
      }, message.messageId);
      ymPushResendAttach(AttachLabel.IMAGE, (_config$authZoneConfi2 = config.authZoneConfig) === null || _config$authZoneConfi2 === void 0 ? void 0 : _config$authZoneConfi2.zoneType);
    }
  };
  var resubmit = function resubmit() {
    resubmitMessages.current.forEach(resubmitMessage);
  };
  useEffect(function () {
    var timeoutId;
    if (isOnline && stage === FSMStages.CONNECTING) {
      if (socketStatus === SocketStatus.idle) {
        void connect({
          onSuccess: resubmit
        });
      }
      if (socketStatus === SocketStatus.closed && reconnectCount <= MAX_RECONNECT_ATTEMPTS) {
        dispatch(setReconnectCount(reconnectCount + 1));
        timeoutId = setTimeout(connect, Number(Boolean(reconnectCount)) * 1000);
      }
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [socketStatus, isOnline, stage]);
  useEffect(function () {
    if (!isOnline) {
      var _socketRef$current;
      (_socketRef$current = socketRef.current) === null || _socketRef$current === void 0 || _socketRef$current.close();
    }
    return function () {
      var _socketRef$current2;
      (_socketRef$current2 = socketRef.current) === null || _socketRef$current2 === void 0 || _socketRef$current2.close();
    };
  }, [isOnline]);
  useEffect(function () {
    if (reconnectCount > MAX_RECONNECT_ATTEMPTS) {
      var _config$authZoneConfi3;
      if (((_config$authZoneConfi3 = config.authZoneConfig) === null || _config$authZoneConfi3 === void 0 ? void 0 : _config$authZoneConfi3.zoneType) === 'unauthorized') {
        changeStage(FSMStages.CAPTCHA_NEEDED);
      } else {
        changeStage(FSMStages.RECONNECT);
      }
    }
  }, [reconnectCount]);
  return params;
};